// Fetch list

export const FETCH = 'packagingTypes.FETCH'
export const FETCH_STARTED = 'packagingTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'packagingTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'packagingTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'packagingTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'packagingTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'packagingTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'packagingTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'packagingTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'packagingTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'packagingTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'packagingTypes.SAVE'
export const SAVE_STARTED = 'packagingTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'packagingTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'packagingTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'packagingTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'packagingTypes.DELETE'
export const DELETE_STARTED = 'packagingTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'packagingTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'packagingTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'packagingTypes.DELETE_CANCELLED'

// Export

export const EXPORT = 'packagingTypes.EXPORT'
export const EXPORT_FULFILLED = 'packagingTypes.EXPORT_FULFILLED'
